<template>
    <div class="tabs-holder">
        <div class="tabs__item listing-container cards-list">

            <template v-if="!$store.state.loadingMain">
                <div class="card" v-for="item in getAllPosts" :class="{'kinozal' : item.kinozal}">
                    <div class="heading2 card__title">{{item.name}}</div>
                    <div class="card-info">
                        <div class="card-info__icon">
                            <svg class="svg-icon">
                                <use href="/wp-content/themes/m9/assets/img/sprites/ic_sprite.svg#svg-internet"></use>
                            </svg>
                        </div>
                        <div class="card-info__title">{{item.plan}}</div>
                        <div class="card-info__subtitle">Интернет</div>
                    </div>


                    <div class="card-info">
                        <div class="card-info__icon">
                            <svg class="svg-icon">
                                <use href="/wp-content/themes/m9/assets/img/sprites/ic_sprite.svg#svg-tv"></use>
                            </svg>
                        </div>
                        <div class="card-info__title">
                            <span v-if="item.kinozal"
                                  @click="moreAboutSub(item.BUNDLE_ID, item.name, item.tv, item.kinozal)"><a>{{item.tvQuantity}}</a></span>
                            <span v-else
                                  @click="moreAboutSub(item.BUNDLE_ID, item.name, item.tv)"><a>{{item.tvQuantity}}</a></span>
                        </div>
                        <div class="card-info__subtitle">Телевидение</div>
                    </div>

                    <div class="card-info" v-if="item.kinozal">
                        <div class="card-info__icon">
                            <svg class="svg-icon">
                                <use href="/wp-content/themes/m9/assets/img/sprites/ic_sprite.svg#svg-tv"></use>
                            </svg>
                        </div>
                        <div class="card-info__title">
                            <span><a>{{item.kinozal}}</a></span></div>
                        <div class="card-info__subtitle">Кинозал</div>
                    </div>

                    <div class="card-bottom content-center">
                        <div class="card-price">
                            <div class="card-price__summ">{{item.priceNumber}}</div>
                            <div class="card-price__format">
                                ₽ <span>мес.</span>
                            </div>
                        </div>

                        <a :href="'/order/?id=' + item.id" class="btn btn--l btn--accent card__connect">Подключить</a>
                    </div>
                </div>
            </template>


            <div class="loader" v-else>
                <span>Загрузка...</span>
            </div>

        </div>
    </div>
</template>

<script>

    import router from '@/router'

    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: 'TvApi',
        data() {
            return {
                btn: true,
                center: false
            }
        },
        computed: {
            ...mapGetters([
                'detailInfo',
                'getAllPosts',
                'getDops'
            ])
        },
        mounted() {

        },
        methods: {
            async moreAboutSub(id, name, kCOL, kinozal) {
                // this.$store.commit('toggleDetailInfo', id);

                await this.$store.commit('globalPacketName', {
                    name: name,
                    kCOL: kCOL
                });
                await this.$store.commit('globalPacketId', id);

                router.push({
                    path: '/tv-services/',
                    query: {}
                });

                if (kinozal){
                    router.push({query: {package: id, tv: kCOL + '+' + kinozal}});
                }
                else {
                    router.push({query: {package: id, tv: kCOL}});
                }

                    this.$store.commit('loadPacket');


                window.scrollTo({
                    top: 0,
                });
            },

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .jcb {
        justify-content: space-between;
    }

    .channels-title {
        font-size: 3.2rem;
        line-height: 1.21875;
        letter-spacing: -0.02em;
        margin-bottom: 40px;
        font-weight: 600;
        font-style: normal;
    }

    .aic {
        align-items: center;
    }

    .jcc {
        justify-content: center !important;
    }

    .loader {
        height: 300px;
        width: 100%;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        color: #000000;
        font-size: 36px;
        text-align: center;
        padding-top: 60px;
    }

    .align-self-top {
        align-self: start;
    }

    .row {
        display: flex;
        flex-wrap: wrap;
    }

    .align-self-center {
        align-self: center;

    }

    .align-self-bottom {
        align-self: end;
    }

    .channels-list {
        margin: 0 -10px;
        display: flex;
        flex-wrap: wrap;
        .channel-item-wrapper {
            padding: 0 10px;
            min-height: 300px;
            width: 33.33333333%;
            margin-bottom: 20px;
            .channel-item {
                padding: 24px;
                min-height: 250px;
                height: 100%;
                border-radius: 8px;
                border: 1px solid rgba(21, 21, 28, 0.15);
                display: flex;
                flex-wrap: wrap;
                cursor: pointer;
                /*&:hover{*/
                /*button{*/
                /*background-color: #a7020d !important;*/
                /*}*/
                /*}*/
                .channel-price {
                    display: flex;
                    align-items: center;
                    .card-price__summ {
                        font-size: 5.6rem;
                        font-weight: 500;
                        line-height: 1.21429;
                        margin-right: 8px;
                    }
                    .card-price__format {
                        font-weight: 500;
                        font-size: 1.7rem;
                        line-height: 1.11765;
                        white-space: nowrap;
                        flex-shrink: 0;
                        span {
                            display: block;
                            margin-top: 5px;
                            position: relative;
                            padding-left: 2px;
                            &:before {
                                content: "";
                                position: absolute;
                                bottom: 100%;
                                height: 1px;
                                left: 2px;
                                right: 8px;
                                background: #15151c;
                            }
                        }
                    }
                }
                .channel-btn {
                    width: 50%;
                    button {
                        cursor: pointer;
                        text-align: center;
                        width: 100%;
                        height: 62px;
                        padding: 0 25px;
                        font-size: 1.7rem;
                        line-height: 1.23529;
                        background-color: #e30613;
                        transition: all .15s;
                        border-radius: 8px;
                        border: 1px solid transparent;
                        color: #ffffff;
                        &:hover {
                            background-color: #a7020d;
                        }
                    }
                }
                .channel-title {
                    font-weight: bold;
                    font-size: 3.2rem;
                    /*margin-bottom: 24px;*/
                }
                .channel-desc {
                    font-size: 1.4rem;
                    color: #848794;
                }
                > div {
                    flex: 0 0 auto;
                    width: 100%;
                }
            }
        }
    }

</style>
